import MultiSelect from './MultiSelect';
import { withFormMeta } from '../../FormMeta';

export default withFormMeta(MultiSelect);
